<i18n src="./../../i18n/product_item.json"></i18n>

<template>
    <div class="container mt-offer-product mb-3">
        <div class="row no-gutters">
            <div class="col-lg-6 mt-product-main-image">
                <img class="lazy" :data-src="itemData.thumbnail" width="350" height="300" :alt="itemData.thumbnailAlt">
            </div>
            <div class="col-lg-6 mt-product-main-details">
                <h2 v-text="itemData.name"/>
                <ul>
                    <li v-for="feature in itemData.features.slice(0, 3)" :key="feature">
                        {{ feature }}
                    </li>
                </ul>
                <div class="row pt-3 mb-3">
                    <div class="col">
                        <router-link :to="{name: 'product', params: {productName: cleanPath(itemData.url)}}">
                            <button type="button" class="btn btn-primary mt-product-btn mt-btn-labeled mt-button mt-button-primary mt-button-fix-width ml-md-2"><font-awesome-icon class="mt-fa-icon" icon="ellipsis-h"/><span class="my-auto" v-text="$t('details')" /></button>
                        </router-link>
                        <button class="button--add-to-cart button button--primary js-form-submit form-submit btn btn-primary" id="edit-submit--2" v-on:click="show(itemData.id)" v-text="$t('evaluate')" />
                        <modal :name="'product-' + itemData.id" height="auto" :scrollable="true" :width="700">
                            <div class="container">
                                <button draggable="false" title="Zamknij" aria-label="Zamknij" type="button" class="gm-ui-hover-effect" v-on:click="hide(itemData.id)">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23000000%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%0A%3C%2Fsvg%3E%0A">
                                </button>
                                <div class="row no-gutters pt-3">
                                    <div class="col-lg-5 mt-product-main-image text-center my-auto">
                                        <img :src="itemData.thumbnail" width="350" height="300" :alt="itemData.thumbnailAlt">
                                    </div>
                                    <div class="col-lg-7 mt-product-main-details">
                                        <h4 v-text="itemData.name" class="pt-2 text-center text-lg-left"/>
                                        <div class="container p-0">
                                            <div v-if="itemData.category === categoryToilets">
                                                <!--liczba osób-->
                                                <div class="row no-gutters pt-3">
                                                    <div class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.numberOfPeople') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters mt-q-input">
                                                        <div class="number-input">
                                                            <button v-on:click="function () {selected.numberOfPeople > 1 ? selected.numberOfPeople-- : ''; updateDefaultQuantityAndService();}"></button>
                                                            <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.numberOfPeople" type="number" @change="updateDefaultQuantityAndService()">
                                                            <button v-on:click="function () {selected.numberOfPeople++; updateDefaultQuantityAndService();}" class="plus"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--liczba kabin-->
                                                <div class="row no-gutters pt-3">
                                                    <!--wyjątek dla umywalki :(-->
                                                    <div v-if="itemData.name.toLowerCase().includes(exceptionWashbasin)" class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.numberOfItems') }}:
                                                    </div>
                                                    <div v-else class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.numberOfCabins') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters mt-q-input">
                                                        <div class="number-input">
                                                            <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                            <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                            <button v-on:click="selected.quantity++" class="plus"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--częstotliwość serwisu-->
                                                <div class="row no-gutters pt-2">
                                                    <div class="col-6 col-lg-7 pl-2 my-auto  text-right pr-4">
                                                        {{ $t('modal.serviceFrequency') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters">
                                                        <select class="mt-form-control" v-model="selected.variation" v-on:change="updatePrice()">
                                                            <option v-for="service in itemData.services" :key="service.id" v-bind:value="service.id" v-text="service.serviceType"/>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="itemData.category === categoryContainers">
                                                <!--liczba kontenerów-->
                                                <div class="row no-gutters pt-3 pb-5 mb-5">
                                                    <div class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.numberOfContainers') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters mt-q-input">
                                                        <div class="number-input">
                                                            <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                            <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                            <button v-on:click="selected.quantity++" class="plus"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="itemData.category === categoryFences">
                                                <!--metrów bieżących-->
                                                <div class="row no-gutters pt-3 pb-5 mb-5">
                                                    <div class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.meters') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters mt-q-input">
                                                        <div class="number-input">
                                                            <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                            <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                            <button v-on:click="selected.quantity++" class="plus"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="itemData.category === categoryOthers">
                                                <!--liczba sztuk-->
                                                <div class="row no-gutters pt-3 pb-5 mb-5">
                                                    <div class="col-6 col-lg-7 pl-2 my-auto text-right pr-4">
                                                        {{ $t('modal.numberOfItems') }}:
                                                    </div>
                                                    <div class="col-6 col-lg-5 no-gutters mt-q-input">
                                                        <div class="number-input">
                                                            <button v-on:click="selected.quantity > 1 ? selected.quantity-- : ''" ></button>
                                                            <input class="quantity mt-cart-quantity" name="quantity" v-model="selected.quantity" type="number">
                                                            <button v-on:click="selected.quantity++" class="plus"></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-4">
                                                <div v-if="this.itemData.canBuy" class="col-6 my-auto text-right pt-2 pb-3 text-nowrap"><span class="price">{{ (selected.quantity * selected.price).toFixed(2) }} {{ currencyShort }}</span> <span class="mt-quantity">/{{ $t('modal.4WeekPrice') }}</span></div>
                                                <div v-else class="col-6 pt-2 pb-3"/>
                                                <div class="col-6 pt-2 pb-3">
                                                    <button class="btn btn-primary btn-lg mt-button mt-button-primary add-to-cart" v-on:click="addToCart()" v-text="$t('modal.addToCart')"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VanillaToasts from 'vanillatoasts'
    import 'vanillatoasts/vanillatoasts.css'
    import {Const} from "@/main";

    export default {
        name: "ProductItem",
        props: {
            itemData: {},
            configuration: {}
        },
        data() {
            return {
                currencyShort: Const.PRIMARY_CURRENCY_SHORT,
                exceptionWashbasin: Const.EXCEPTION_WASHBASIN,
                categoryToilets: Const.CATEGORY_TOILETS,
                categoryContainers: Const.CATEGORY_CONTAINERS,
                categoryFences: Const.CATEGORY_FANCIES,
                categoryOthers: Const.CATEGORY_OTHERS,
                selected: {
                    id: Number,
                    numberOfPeople: Number,
                    quantity: Number,
                    variation: Number,
                    price: Number
                }
            }
        },
        methods: {
            show (id) {
                this.$modal.show('product-' + id)
                this.selected.id = id;
                this.selected.numberOfPeople = 1;
                this.selected.quantity = 1;
                this.selected.variation = this.getDefaultVariation();
                this.selected.price = this.getServicePriceById(this.selected.variation);
            },
            hide (id) {
                this.$modal.hide('product-' + id);
            },
            updatePrice() {
                if (this.itemData.canBuy) {
                    this.selected.price = this.getServicePriceById(this.selected.variation);
                }
            },
            addToCart() {
                this.hide(this.selected.id)
                this.$store.dispatch('addToCart', {
                    id: this.selected.id,
                    variation: this.selected.variation,
                    quantity: this.selected.quantity,
                    category: this.itemData.category,
                    canBuy: this.itemData.canBuy,
                    name: this.itemData.name,
                    url: this.itemData.url,
                    thumbnail: this.itemData.thumbnail,
                    features: this.itemData.features.slice(0, 3),
                    availableAdditionalServices: this.itemData.additionalServices,
                    possibleVariations: this.itemData.services
                });
                VanillaToasts.create({
                    title: this.$t('messages.productAdded'),
                    type: 'success',
                    timeout: 2000,
                });
            },
            getDefaultVariation() {
                if (this.itemData.category === this.categoryToilets) {
                    return Math.max.apply(Math, this.itemData.services.map(function (o) { return o.id; }))
                } else {
                    return 0
                }
            },
            updateDefaultQuantityAndService() {
                let conf = this.configuration.find(obj => {
                    return obj.numberOfPeople >= this.selected.numberOfPeople
                })
                this.selected.quantity = conf.numberOfProducts
                this.selected.variation = Math.min(this.getDefaultVariation(), conf.serviceId)
                this.updatePrice()
            },
            getServicePriceById(id) {
                if (this.itemData.canBuy) {
                    for (let key in this.itemData.services) {
                        if (this.itemData.services[key].id === id)
                            return this.itemData.services[key].grossPrice;
                    }

                    return '-';
                }
            },
            getServiceDescriptionById(id) {
                for (let key in this.itemData.services) {
                    if (this.itemData.services[key].id === id)
                        return this.itemData.services[key].serviceType;
                }

                return '-';
            },
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            }
        }
    }
</script>

<style scoped>
    .mt-product-btn {
        height: 46px;
        margin: 7px;
        padding: 7px;
    }

    #edit-submit--2 {
        margin: 8px;
    }

    .mt-fa-icon {
        width: 3em;
        height: 2em;
        vertical-align: middle;
    }

    .mt-form-control {
        display: block;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    }

    select {
        width: 144px;
    }

    .add-to-cart {
        width: inherit;
    }

    .price {
        font-size: 1.3rem;
        font-weight: 700;
        color: #e30613;
    }

    .mt-quantity {
        font-size: 0.8rem;
        color: #999fa5;
    }

    .gm-ui-hover-effect {
        background: none;
        display: block;
        border: 0;
        margin: 0;
        padding: 0;
        position: absolute;
        cursor: pointer;
        user-select: none;
        top: -6px;
        right: -6px;
        width: 30px;
        height: 30px;
    }

    .gm-ui-hover-effect:focus {
        outline: 0;
    }

    .gm-ui-hover-effect img {
        pointer-events: none;
        display: block;
        width: 14px;
        height: 14px;
        margin: 8px;
    }

    @media (max-width: 650px) {
        /deep/.v--modal-box {
            width: 90% !important;
            left: 0 !important;
            right: 0;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .mt-product-main-image img {
        max-width: 100%;
        height: auto;
    }

    .mt-offer-product {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7;
    }

    .mt-product-main-details > div > div > div.field {
        margin: 8px;
    }

    @media (max-width: 992px) {
        .mt-product-main-details button.btn {
            width: 100%;
            margin-bottom: 10px;
        }

        .mt-product-main-details > div > div > div.field {
            width: 100%;
            margin: 0;
        }

        .mt-product-main-details .modal-body img {
            max-width: 100%;
            height: auto;
        }
    }

    .mt-offer-product:hover {
        border-color: #4092e5;
    }

    .button--add-to-cart {
        background-color: #fff;
        color: #000;
        width: 150px;
        border: solid 1px #4092e5;
        border-radius: 0;
        padding: .7rem 1.5rem;
        font-size: .9rem;
    }

    .button--add-to-cart:hover {
        background-color: #e5f3ff;
        color: #000;
    }
</style>